"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuFooter = _interopRequireDefault(require("./FooterVariants/MenuFooter"));

var _PrimaryFooter = _interopRequireDefault(require("./FooterVariants/PrimaryFooter"));

var Footer = function Footer(_ref) {
  var columns = _ref.columns,
      copyrightText = _ref.copyrightText,
      secondaryLinks = _ref.secondaryLinks,
      social = _ref.social,
      variation = _ref.variation,
      rest = _objectWithoutProperties(_ref, ["columns", "copyrightText", "secondaryLinks", "social", "variation"]);

  var footerProps = {
    columns: columns,
    copyrightText: copyrightText,
    secondaryLinks: secondaryLinks,
    social: social
  };

  if (variation === 'menu') {
    return /*#__PURE__*/_react.default.createElement(_MenuFooter.default, Object.assign({}, footerProps, rest));
  }

  if (variation === 'primary') {
    return /*#__PURE__*/_react.default.createElement(_PrimaryFooter.default, Object.assign({}, footerProps, rest));
  }

  return null;
};

Footer.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOf(['nav', 'html']),
    component: _propTypes.default.shape({})
  })),
  copyrightText: _propTypes.default.string,
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  social: _propTypes.default.shape({
    media: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string,
      url: _propTypes.default.string
    })),
    text: _propTypes.default.string
  }),
  variation: _propTypes.default.oneOf(['primary', 'menu'])
};
Footer.defaultProps = {
  columns: [],
  copyrightText: 'Copyright Ascential Events (Europe) Limited',
  secondaryLinks: [],
  social: null,
  variation: 'primary'
};
var _default = Footer;
exports.default = _default;